import Container from '../Container';
import React, { Component } from 'react';
import { V_BOX_PROPS } from './Types';

export default class VBox extends Component<V_BOX_PROPS> {
  static defaultProps = {
    vBox: true
  }

  constructor(props: any) {
    super(props);
  }
    
  render() {
    return (
      <Container
        {...this.props}
        vBox
      />
    );
  }
}
